import { makeAutoObservable } from 'mobx'
import { OpenBankingPaymentSummary } from './Radom'

/**
 * Opens the open-banking payment drawer from anywhere in the app without
 * navigating. The drawer is mounted once at the App root and loads the
 * payment by the id of its checkout session.
 */
class OpenBankingPaymentController {
  // Both fields are initialised so that they exist when the store is made
  // observable: a field that is only declared is not tracked.
  checkoutSessionId: string | undefined = undefined

  /** What the caller already knows about the payment, shown while the rest loads. */
  seed: OpenBankingPaymentSummary | undefined = undefined

  constructor () {
    makeAutoObservable(this)
  }

  open = (checkoutSessionId: string, seed?: OpenBankingPaymentSummary): void => {
    this.seed = seed
    this.checkoutSessionId = checkoutSessionId
  }

  close = (): void => {
    this.checkoutSessionId = undefined
    this.seed = undefined
  }
}

export default new OpenBankingPaymentController()
